import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import proToast from '../../functions/toast';
// import PocketBase from 'pocketbase';
// import {icon} from "@fortawesome/fontawesome-svg-core";
// import {baseUrl} from "../../../../globals";
import { HttpClient } from '@angular/common/http';
import { feedbackUrl } from 'src/globals';

@Component({
  selector: 'app-feedback-popup',
  templateUrl: './feedback-popup.component.html',
  styleUrls: ['./feedback-popup.component.css'],
})
export class FeedbackPopupComponent {
  // pb = new PocketBase('http://172.27.33.86:1998');
  ///This server is a reverse proxy for the server above http://172.27.33.86:1998
  // pb = new PocketBase('https://tenders.telone.co.zw:1930');
  // feedbackUrl = 'https://springapi.telone.co.zw/feedbackApi/api/v1/feedback';
  // feedbackUrl = 'http://172.27.34.22:3033/api/Fdbk';
  // feedbackUrl = 'http://localhost:3000/api/feedback';
  showPopup = false;
  loading = false;
  isSending: boolean = false;
  feedbackForm!: FormGroup; // <-- Declare the form group

  constructor(private fb: FormBuilder, private http: HttpClient) {}

  onButtonClick() {
    this.showPopup = true;
    document
      .querySelector('.feedback-button')
      ?.classList.replace('button-visible', 'button-hidden');
    document
      .querySelector('.feedback-modal')
      ?.classList.replace('modal-hidden', 'modal-visible');
    // Handle the button click here
  }

  onCancelClick() {
    this.showPopup = false;
    document
      .querySelector('.feedback-button')
      ?.classList.replace('button-hidden', 'button-visible');
    document
      .querySelector('.feedback-modal')
      ?.classList.replace('modal-visible', 'modal-hidden');
  }

  // Custom validator function for word count
  maxWordsValidator(maxWords: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // Skip if empty

      const words = control.value.trim().split(/\s+/).filter(Boolean); // Split into words
      return words.length > maxWords
        ? { maxWords: { maxWords, actual: words.length } }
        : null;
    };
  }

  ngOnInit() {
    this.feedbackForm = this.fb.group({
      feedback: ['', [Validators.required, this.maxWordsValidator(50)]], // 50-word limit
      name: ['', Validators.required],
      email: ['', Validators.required],
      cellNumber: ['', Validators.required],
    });
  }

  get feedbackErrors() {
    return this.feedbackForm.get('feedback')?.errors || {};
  }

  onSubmit() {
    if (this.feedbackForm.valid) {
      // Handle the form submit here

      // const browserName = navigator.appName;

      //const landLine = this.feedbackForm.value.landLine ?? '';

      const feedbackMessage: string = this.feedbackForm.value.feedback ?? '';
      const name: string = this.feedbackForm.value.name ?? '';
      const email: string = this.feedbackForm.value.email ?? '';
      const cellNumber: string = this.feedbackForm.value.cellNumber ?? '';

      console.log(`Feedback message: ${feedbackMessage}`);

      const feedbackData = {
        // if appId = 3 -> Careers Platform
        appId: '3',
        platform: 'E-Recruitment',
        name: name,
        email: email,
        landline: '024200000',
        message: feedbackMessage,
        cellnumber: cellNumber,
      };
      //const feedbackData = this.feedbackForm.value;
      console.log(feedbackData);

      this.loading = true;
      this.isSending = true;
      this.http.post(`${feedbackUrl}`, feedbackData).subscribe(
        (response: any) => {
          this.loading = false;
          this.isSending = false;
          proToast.fire({
            icon: 'success',
            title: 'Thank you for your feedback!',
          });
          console.log('Feedback submitted successfully', response);
          this.feedbackForm.reset();
        },
        (error: any) => {
          this.loading = false;
          this.isSending = false;
          proToast.fire({
            icon: 'error',
            title: "Oops! Something went wrong, your feedback wasn't sent.",
          });
          console.log(error);
        },
        () => {
          this.loading = false;
          this.showPopup = false;
        }
      );
    } else {
      Object.keys(this.feedbackForm.controls).forEach((field) => {
        const control = this.feedbackForm.get(field);
        control!.markAsTouched({ onlySelf: true });
      });
    }
  }

  // Add feedback
  /* addFeedback(feedback: Feedback) {
    this.feedbackService.addFeedback(feedback).subscribe(
      (newFeedback: Feedback) => {
        this.loading = false;
        this.feedbacks.push(newFeedback);
        proToast.fire({
          icon: 'success',
          title: 'Feedback sent',
        });
      },
      (error: any) => {
        this.loading = false;
        proToast.fire({
          icon: 'error',
          title: "Something went wrong feedback wasn't sent",
        });
        console.log(error);
      },
      () => {
        this.loading = false;
        this.showPopup = false;
      }
    );
  } */

  // example create data
}
